import React from "react";
type searchProps = {
  data: row[];
  serarchVal: string;
  setSearchVal: React.Dispatch<React.SetStateAction<string>>;
  setCurrentPage?: React.Dispatch<React.SetStateAction<number>>;
  setData: React.Dispatch<React.SetStateAction<row[]>>;
};
const inputContainerStyle = {
  height: "45px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "10px",
  overflow: "hidden",
  cursor: "pointer",
  border: "1px solid gray",
  paddingLeft: "15px",
  boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.075)",
  width: "250px",
  // margin: "0px 0px 10px 0px",
};
const inputStyle = {
  width: "170px",
  height: "100%",
  border: "none",
  outline: "none",
  fontSize: "0.9em",
  background: "transparent",
  caretColor: "rgb(255, 81, 0)",
};
const labelForSearchStyle = {
  cursor: "text",
  padding: "0px 12px",
};

const SearchData = (props: searchProps) => {
  const { data, serarchVal, setData, setCurrentPage, setSearchVal } = props;
  function searchObjects(searchTerm: string) {
    const searchTermLower = searchTerm.toLowerCase();
    const results = data.filter((obj) => {
      return Object.values(obj).some(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(searchTermLower)
      );
    });
    return results;
  }
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchVal(e.target.value);
    const searchResults: row[] = searchObjects(e.target.value);
    if (setCurrentPage) setCurrentPage(1);
    setData(searchResults);
  };

  return (
    <>
      <div className="InputContainer" style={inputContainerStyle}>
        <input
          type="search"
          name="text"
          className="input"
          style={inputStyle}
          id="input"
          placeholder="Search"
          value={serarchVal}
          onChange={(e) => handleSearch(e)}
        />
        <label style={labelForSearchStyle}>
          <svg viewBox="0 0 512 512" style={{ width: 13 }}>
            <path
              fill="rgb(114, 114, 114)"
              d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
            ></path>
          </svg>
        </label>
      </div>
    </>
  );
};

export default SearchData;

type pageProp = {
  pageSize: number;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
};

export const PageSizeSelect = (props: pageProp) => {
  const { pageSize, setPageSize } = props;
  return (
    <div
      className="pageContainer d-flex align-items-center gap-2"
      style={{ display: "flex", alignItems: "center", gap: 8 }}
    >
      show
      <select
        value={pageSize}
        className="form-control"
        onChange={(e) => setPageSize(parseInt(e.target.value))}
      >
        <option>05</option>
        <option>10</option>
        <option>15</option>
        <option>20</option>
        <option>50</option>
        <option>100</option>
      </select>
      enteries
    </div>
  );
};
